import { render, staticRenderFns } from "./HealthReports.vue?vue&type=template&id=a19b4662"
import script from "./HealthReports.vue?vue&type=script&lang=js"
export * from "./HealthReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports